<template>
  <label class="tw-group tw-relative tw-inline-flex">
    <input
      :id="id"
      :name="id"
      type="checkbox"
      class="tw-peer tw-sr-only"
      :disabled="disabled"
      :checked="checked"
      :data-testid="id"
      :aria-label="ariaLabel || undefined"
      @input="$event => $emit('update:checked', $event)"
    />
    <div
      class="tw-peer tw-h-6 tw-w-12 tw-rounded-full tw-bg-slate-300 after:tw-absolute after:tw-left-[2px] after:tw-top-[2px] after:tw-h-5 after:tw-w-5 after:tw-rounded-full after:tw-bg-white after:tw-transition-all after:tw-content-[''] peer-checked:tw-bg-black peer-checked:after:tw-translate-x-6 peer-focus:tw-ring-2 peer-focus:tw-ring-deep-orange-600 dark:tw-bg-slate-400 after:dark:tw-bg-black"
      :class="{
        'tw-cursor-pointer': !disabled,
        'tw-cursor-not-allowed !tw-bg-slate-200 peer-checked:tw-bg-deep-orange-300 dark:!tw-bg-slate-700': disabled
      }"
    />
    <div
      v-if="disabled && disabledReason"
      role="tooltip"
      class="tw-pointer-events-none tw-absolute tw-bottom-full tw-right-0 tw-mb-2 tw-hidden tw-w-max tw-max-w-[200px] tw-whitespace-normal tw-rounded tw-bg-gray-800 tw-px-2 tw-py-1 tw-text-xs tw-text-white group-hover:tw-block"
    >
      {{ disabledReason }}
    </div>
  </label>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'StudioToggle',
  props: {
    checked: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    disabledReason: {
      type: String,
      default: ''
    },
    id: {
      type: String,
      default: 'studio-toggle'
    },
    ariaLabel: {
      type: String,
      default: ''
    }
  },
  emits: ['update:checked']
});
</script>
